import { render } from "./StatusLevelCitizen.vue?vue&type=template&id=33db2020&scoped=true"
import script from "./StatusLevelCitizen.vue?vue&type=script&lang=js"
export * from "./StatusLevelCitizen.vue?vue&type=script&lang=js"

import "./StatusLevelCitizen.vue?vue&type=style&index=0&id=33db2020&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/oneGov-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33db2020"]])

export default __exports__